module.exports = __webpack_public_path__ + "static/media/pink_animal_insects_5.d5df96f4.png";